var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotepadChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7.8335C4.5 7.55735 4.72386 7.3335 5 7.3335H9C9.27614 7.3335 9.5 7.55735 9.5 7.8335C9.5 8.10964 9.27614 8.3335 9 8.3335H5C4.72386 8.3335 4.5 8.10964 4.5 7.8335Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 11.25C9.91421 11.25 10.25 11.5858 10.25 12L10.25 15C10.25 15.4142 9.91421 15.75 9.5 15.75C9.08579 15.75 8.75 15.4142 8.75 15L8.75 12C8.75 11.5858 9.08579 11.25 9.5 11.25Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13.25C13.9142 13.25 14.25 13.5858 14.25 14L14.25 15C14.25 15.4142 13.9142 15.75 13.5 15.75C13.0858 15.75 12.75 15.4142 12.75 15L12.75 14C12.75 13.5858 13.0858 13.25 13.5 13.25Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 9.25C11.9142 9.25 12.25 9.58579 12.25 10L12.25 15C12.25 15.4142 11.9142 15.75 11.5 15.75C11.0858 15.75 10.75 15.4142 10.75 15L10.75 10C10.75 9.58579 11.0858 9.25 11.5 9.25Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 5.33228C4.5 5.05613 4.72386 4.83228 5 4.83228H6.33333C6.60948 4.83228 6.83333 5.05613 6.83333 5.33228C6.83333 5.60842 6.60948 5.83228 6.33333 5.83228H5C4.72386 5.83228 4.5 5.60842 4.5 5.33228Z",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33145 2.74756C3.00897 2.74756 2.74756 3.00897 2.74756 3.33145V12.6687C2.74756 12.9911 3.00897 13.2526 3.33145 13.2526H5.99923C6.41344 13.2526 6.74923 13.5883 6.74923 14.0026C6.74923 14.4168 6.41344 14.7526 5.99923 14.7526H3.33145C2.18055 14.7526 1.24756 13.8196 1.24756 12.6687V3.33145C1.24756 2.18055 2.18055 1.24756 3.33145 1.24756H8.78143C9.33411 1.24756 9.86416 1.46711 10.255 1.85792L12.1414 3.74432C12.5322 4.13512 12.7517 4.66517 12.7517 5.21785V6.66617C12.7517 7.08038 12.4159 7.41617 12.0017 7.41617C11.5875 7.41617 11.2517 7.08038 11.2517 6.66617V5.21785C11.2517 5.06299 11.1902 4.91448 11.0807 4.80498L11.611 4.27465L11.0807 4.80498L9.19431 2.91858L9.72464 2.38825L9.1943 2.91858C9.0848 2.80908 8.93629 2.74756 8.78143 2.74756H3.33145Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotepadChart);
export default __webpack_public_path__ + "static/media/icon-notepad-chart.632ef41e3e6eed8ca4d87b86b54fbf70.svg";
export { ForwardRef as ReactComponent };